import { narrowAssetLanguage } from "../vod-title";
const UNSPECIFIED = new Set(["und", "zxx", "mis", "mul"]);
const ALPHA3_TO_ALPHA2 = {
    ara: "ar",
    ces: "cs",
    cze: "cs",
    dan: "da",
    deu: "de",
    ell: "el",
    eng: "en",
    est: "et",
    fao: "fo",
    fas: "fa",
    fin: "fi",
    fra: "fr",
    fre: "fr",
    ger: "de",
    gre: "el",
    heb: "he",
    hin: "hi",
    hun: "hu",
    isl: "is",
    ice: "is",
    ita: "it",
    jpn: "ja",
    kor: "ko",
    lav: "lv",
    lit: "lt",
    dut: "nl",
    nld: "nl",
    nno: "nn",
    nob: "nb",
    nor: "no",
    per: "fa",
    pol: "pl",
    por: "pt",
    ron: "ro",
    rum: "ro",
    rus: "ru",
    slk: "sk",
    slo: "sk",
    spa: "es",
    swe: "sv",
    tur: "tr",
    ukr: "uk",
    zho: "zh",
    chi: "zh",
};
function matchLanguage(value) {
    var _a;
    const narrowed = narrowAssetLanguage(value);
    if (!narrowed)
        return null;
    const code = (_a = ALPHA3_TO_ALPHA2[narrowed.code]) !== null && _a !== void 0 ? _a : narrowed.code;
    return UNSPECIFIED.has(code) ? null : code;
}
function displayNames(locale) {
    try {
        const Ctor = Intl.DisplayNames;
        if (typeof Ctor !== "function")
            return null;
        return new Ctor([locale], { type: "language" });
    }
    catch {
        return null;
    }
}
function titleCase(text) {
    return text.length === 0 ? text : text[0].toUpperCase() + text.slice(1);
}
function roleNote(track) {
    var _a;
    const roles = ((_a = track.roles) !== null && _a !== void 0 ? _a : []).map((r) => r.toLowerCase());
    if (roles.includes("commentary"))
        return "Commentary";
    if (roles.includes("description"))
        return "Audio description";
    if (track.kind === "caption" || roles.includes("caption")) {
        return "For the hard of hearing";
    }
    if (roles.includes("dub"))
        return "Dubbed";
    return null;
}
function optionLabel(track, code, names) {
    var _a;
    const fromLocale = code ? names === null || names === void 0 ? void 0 : names.of(code) : undefined;
    if (fromLocale && fromLocale.toLowerCase() !== code)
        return titleCase(fromLocale);
    const label = (_a = track.label) === null || _a === void 0 ? void 0 : _a.trim();
    if (label)
        return label;
    if (code)
        return code.toUpperCase();
    return "Original";
}
export function trackOptions(tracks, kind, locale = "en") {
    const names = displayNames(locale);
    const byKey = new Map();
    for (const track of tracks) {
        const raw = typeof track.language === "string" ? track.language.trim() : "";
        const code = matchLanguage(raw);
        const note = roleNote(track);
        const key = `${code !== null && code !== void 0 ? code : `raw:${raw.toLowerCase()}`}|${note !== null && note !== void 0 ? note : ""}`;
        const existing = byKey.get(key);
        if (existing) {
            existing.ids.push(track.id);
            existing.active = existing.active || track.active === true;
            continue;
        }
        byKey.set(key, {
            kind,
            value: key,
            language: code,
            rawLanguage: raw,
            label: optionLabel(track, code, names),
            note,
            ids: [track.id],
            active: track.active === true,
        });
    }
    return [...byKey.values()].sort((a, b) => {
        if (!!a.note !== !!b.note)
            return a.note ? 1 : -1;
        if (!!a.language !== !!b.language)
            return a.language ? -1 : 1;
        return a.label.localeCompare(b.label);
    });
}
function canonicalSet(values) {
    const out = new Set();
    for (const value of values) {
        const code = matchLanguage(value);
        if (code)
            out.add(code);
    }
    return out;
}
function optionLanguages(options) {
    return canonicalSet(options.map((o) => o.language));
}
function missing(from, inside) {
    return [...from].filter((code) => !inside.has(code)).sort();
}
export function reconcileLanguages(audio, text, catalogue) {
    var _a, _b;
    if (!catalogue)
        return [];
    const out = [];
    const audioPackaged = optionLanguages(audio);
    const textPackaged = optionLanguages(text);
    const audioPromised = canonicalSet((_a = catalogue.audioLanguages) !== null && _a !== void 0 ? _a : []);
    const textPromised = canonicalSet((_b = catalogue.subtitleLanguages) !== null && _b !== void 0 ? _b : []);
    const add = (code, languages) => {
        if (languages.length > 0)
            out.push({ code, languages });
    };
    if (audioPromised.size > 0) {
        add("audio_promised_not_packaged", missing(audioPromised, audioPackaged));
        add("audio_packaged_not_promised", missing(audioPackaged, audioPromised));
    }
    if (textPromised.size > 0) {
        add("subtitle_promised_not_packaged", missing(textPromised, textPackaged));
        add("subtitle_packaged_not_promised", missing(textPackaged, textPromised));
    }
    const spoken = canonicalSet([catalogue.spokenLanguage]);
    if (spoken.size > 0 && audioPackaged.size > 0) {
        add("spoken_language_not_packaged", missing(spoken, audioPackaged));
    }
    return out;
}
export function describeDisagreement(d) {
    return `${d.code}=${d.languages.join(",")}`;
}
